import { Component } from "react";
import { Button } from "@/components/ui/button";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
  }

  handleReload = () => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        Promise.all(regs.map((r) => r.unregister())).finally(() => {
          caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k)))).finally(() => {
            window.location.reload();
          });
        });
      });
      return;
    }
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-white rounded-2xl border border-slate-200 shadow-sm p-8 text-center space-y-4">
          <h1 className="font-heading text-2xl font-bold text-slate-900 uppercase">Oups</h1>
          <p className="text-slate-500 text-sm leading-relaxed">
            L&apos;application n&apos;a pas pu démarrer. Cela arrive parfois après une mise à jour sur mobile.
          </p>
          <Button onClick={this.handleReload} className="w-full rounded-full bg-blue-600 hover:bg-blue-700">
            Recharger l&apos;application
          </Button>
        </div>
      </div>
    );
  }
}